module.exports = __webpack_public_path__ + "img/g2.a60cc012.jpeg";